<div id="upload-preview" [style.height.px]="viewHeight">
  <ion-slides #slides (ionSlideDidChange)="slideChanged($event)">
    <ion-slide *ngFor="let file of files">
      <div class="slide-wrapper">
        <div *ngIf="file.isVideo == false && file.isEmbedVideo == false" class="slide-image" (click)="expandFile(file)"
          [style.background-image]="'url(' + file.safeUrl + '?ts=' + tsNow + ')'">
          <img *ngIf="file.isBlob" [src]="file.safeUrl">
        </div>
        <ng-container *ngIf="file.isVideo">
          <canvas id="thumbnail" hidden="hidden"></canvas>
          <video id="video-player" controls="true" loop="true" (click)="videoClicked($event)"
            [attr.poster]="allowRemove == false ? file.thumbPath : null" muted="true"
            [attr.preload]="allowRemove ? 'auto' : 'metadata'" playsinline="true">
            <source *ngFor="let source of file.videoSources" [src]="source.safeUrl" [type]="source.mimeType">
            <source [src]="file.safeUrl" [type]="file.mimeType">
          </video>
        </ng-container>
        <ng-container *ngIf="file.isEmbedVideo">
          <iframe width="100%" height="100%" [src]="file.safeUrl" title="Video Link" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </ng-container>
        <p class="slide-caption">{{file.description}}</p>
      </div>
    </ion-slide>
    <ion-slide *ngIf="files.length === 0">
      <h3 *ngIf="files.length === 0">{{uploadTitle}}</h3>
    </ion-slide>
  </ion-slides>
</div>
<div class="thumbnails" *ngIf="files.length > 0 && showThumbnails">
  <div class="thumb-scroll">
    <div class="thumb-nav">
      <ion-button class="thumb-prev ion-no-padding" fill="clear" size="large" (click)="prev()">
        <ion-icon slot="icon-only" color="primary" name="arrow-back-circle"></ion-icon>
      </ion-button>
    </div>
    <div class="thumbnail-wrapper">
      <div class="thumbnail-row">
        <div class="thumbnail" (click)="setImage(i)" *ngFor="let file of files; index as i"
          [class.active]="activeIndex === i" [style.height.px]="thumbSize" [style.width.px]="thumbSize"
          [style.background-image]="'url(' + file.safeUrl + '?ts=' + tsNow + ')'" [id]="'thumb' + i">
          <img *ngIf="file.isBlob || file.isVideo" [src]="file.thumbPath">
          <img *ngIf="file.isEmbedVideo" src="assets/img/play.png">
          <ion-icon name="close-circle-outline" color="danger" *ngIf="activeIndex === i && allowRemove"
            (click)="removeImage(file)">
          </ion-icon>
        </div>
      </div>
    </div>
    <div class="thumb-nav">
      <ion-button class="thumb-prev ion-no-padding" fill="clear" size="large" (click)="next()">
        <ion-icon slot="icon-only" name="arrow-forward-circle"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>